import { User, Bot, Rocket, CheckCircle, XCircle, PartyPopper, Info, AlertTriangle } from 'lucide-react'

// Message type icons and styles
const MESSAGE_TYPES = {
  info: {
    icon: Rocket,
    iconClass: 'text-primary-400',
    bgClass: 'bg-primary-500/5 border-primary-500/20',
    glowClass: 'shadow-primary-500/10',
  },
  success: {
    icon: CheckCircle,
    iconClass: 'text-emerald-400',
    bgClass: 'bg-emerald-500/5 border-emerald-500/20',
    glowClass: 'shadow-emerald-500/10',
  },
  error: {
    icon: XCircle,
    iconClass: 'text-red-400',
    bgClass: 'bg-red-500/5 border-red-500/20',
    glowClass: 'shadow-red-500/10',
  },
  warning: {
    icon: AlertTriangle,
    iconClass: 'text-amber-400',
    bgClass: 'bg-amber-500/5 border-amber-500/20',
    glowClass: 'shadow-amber-500/10',
  },
  celebration: {
    icon: PartyPopper,
    iconClass: 'text-accent-400 animate-bounce',
    bgClass: 'bg-gradient-to-br from-primary-500/10 to-accent-500/10 border-accent-500/30',
    glowClass: 'shadow-accent-500/20 shadow-lg',
  },
}

export default function Message({ message }) {
  const isUser = message.role === 'user'
  const typeConfig = message.type ? MESSAGE_TYPES[message.type] : null
  const TypeIcon = typeConfig?.icon

  // Simple markdown-ish rendering
  const renderContent = (content) => {
    // Bold
    let html = content.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    // Code
    html = html.replace(/`([^`]+)`/g, '<code class="bg-slate-700 px-1 py-0.5 rounded text-primary-300">$1</code>')
    // Line breaks
    html = html.replace(/\n/g, '<br />')

    return <span dangerouslySetInnerHTML={{ __html: html }} />
  }

  return (
    <div className={`flex gap-3 ${isUser ? 'flex-row-reverse' : ''}`}>
      <div
        className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${
          isUser ? 'bg-primary-600' : 'bg-slate-700'
        }`}
      >
        {isUser ? (
          <User className="w-4 h-4" />
        ) : (
          <Bot className="w-4 h-4" />
        )}
      </div>

      <div
        className={`max-w-[80%] px-4 py-3 rounded-2xl transition-all ${
          isUser
            ? 'bg-primary-600 rounded-br-sm'
            : typeConfig
              ? `${typeConfig.bgClass} ${typeConfig.glowClass} border rounded-bl-sm`
              : 'bg-slate-800 rounded-bl-sm'
        }`}
      >
        {typeConfig && TypeIcon && (
          <div className="flex items-center gap-2 mb-2">
            <div className={`p-1.5 rounded-lg bg-slate-800/50 backdrop-blur-sm`}>
              <TypeIcon className={`w-4 h-4 ${typeConfig.iconClass}`} />
            </div>
            {message.type === 'celebration' && (
              <span className="text-xs font-medium text-accent-300 tracking-wide uppercase">
                Félicitations
              </span>
            )}
          </div>
        )}
        <div className="text-sm leading-relaxed">
          {renderContent(message.content)}
        </div>
      </div>
    </div>
  )
}
